import { lazy, Suspense } from 'react';
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const ShopifyAuth = lazy(() => import('./Shopify/shopify-auth'));
const ShopifyCallback = lazy(() => import('./Shopify/shopify-callback'));
const ShopifyReapproval = lazy(() => import('./Shopify/shopify-reapproval'));
const ShopifyBillingCallback = lazy(() => import('./Shopify/shopify-billing-callback'));

// Wrap components in Suspense
const LoadableShopifyAuth = () => (
  <Suspense fallback={<SplashScreen />}>
    <ShopifyAuth />
  </Suspense>
);

const LoadableShopifyCallback = () => (
  <Suspense fallback={<SplashScreen />}>
    <ShopifyCallback />
  </Suspense>
);

const LoadableShopifyReapproval = () => (
  <Suspense fallback={<SplashScreen />}>
    <ShopifyReapproval />
  </Suspense>
);

const LoadableShopifyBillingCallback = () => (
  <Suspense fallback={<SplashScreen />}>
    <ShopifyBillingCallback />
  </Suspense>
);

// ----------------------------------------------------------------------

export const shopifyRoutes = [
  {
    path: 'shopify',
    children: [
      { path: 'auth', element: <LoadableShopifyAuth /> },
      { path: 'callback', element: <LoadableShopifyCallback /> },
      { path: 'reapproval', element: <LoadableShopifyReapproval /> },
      { path: 'billing_callback', element: <LoadableShopifyBillingCallback /> },
    ],
  },
];
